export default __webpack_public_path__ + "assets/simg2_1simg2.8f581266.avif";